import React from "react";

const OnfidoCheckError = () => (
  <svg
    width="244"
    height="187"
    viewBox="0 0 244 187"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d)">
      <rect x="4.5" y="104" width="104" height="65" rx="8" fill="#E9EFF5" />
      <rect
        x="6"
        y="105.5"
        width="101"
        height="62"
        rx="6.5"
        stroke="#B7CCE1"
        strokeWidth="3"
      />
    </g>
    <rect
      opacity="0.8"
      x="51.5"
      y="138"
      width="50"
      height="4"
      rx="2"
      fill="#D6E3F0"
    />
    <rect
      opacity="0.8"
      x="44.5"
      y="130"
      width="57"
      height="4"
      rx="2"
      fill="#D6E3F0"
    />
    <rect
      opacity="0.8"
      x="52.5"
      y="123"
      width="49"
      height="4"
      rx="2"
      fill="#D6E3F0"
    />
    <path
      d="M34.007 126.653C34.007 130.277 31.0763 133.216 27.4611 133.216C23.846 133.216 20.9153 130.277 20.9153 126.653C20.9153 123.028 23.846 120.09 27.4611 120.09C31.0763 120.09 34.007 123.028 34.007 126.653Z"
      fill="white"
      fillOpacity="0.1"
    />
    <path
      d="M39.4982 142.024C39.0325 140.312 37.4813 139.124 35.7112 139.124H19.2094C17.4392 139.124 15.8881 140.312 15.4224 142.024L13.363 149.595C12.909 151.264 14.1622 152.909 15.8877 152.909H39.0329C40.7584 152.909 42.0116 151.264 41.5576 149.595L39.4982 142.024Z"
      fill="white"
      fillOpacity="0.1"
    />
    <path
      d="M34.007 126.653C34.007 130.277 31.0763 133.216 27.4611 133.216C23.846 133.216 20.9153 130.277 20.9153 126.653C20.9153 123.028 23.846 120.09 27.4611 120.09C31.0763 120.09 34.007 123.028 34.007 126.653Z"
      stroke="#D6E3F0"
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path
      d="M39.4982 142.024C39.0325 140.312 37.4813 139.124 35.7112 139.124H19.2094C17.4392 139.124 15.8881 140.312 15.4224 142.024L13.363 149.595C12.909 151.264 14.1622 152.909 15.8877 152.909H39.0329C40.7584 152.909 42.0116 151.264 41.5576 149.595L39.4982 142.024Z"
      stroke="#D6E3F0"
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <g filter="url(#filter1_d)">
      <rect x="56.5" y="21" width="154" height="160" rx="12" fill="#E9EFF5" />
      <rect
        x="58"
        y="22.5"
        width="151"
        height="157"
        rx="10.5"
        stroke="#B7CCE1"
        strokeWidth="3"
      />
    </g>
    <rect x="105.5" y="60" width="27.8848" height="6" rx="2" fill="#D6E3F0" />
    <rect x="105.5" y="49" width="49" height="6" rx="2" fill="#D6E3F0" />
    <rect x="105.5" y="38" width="39" height="6" rx="2" fill="#D6E3F0" />
    <path
      d="M91.9375 50.1875C91.9375 56.4007 86.9007 61.4375 80.6875 61.4375C74.4743 61.4375 69.4375 56.4007 69.4375 50.1875C69.4375 43.9743 74.4743 38.9375 80.6875 38.9375C86.9007 38.9375 91.9375 43.9743 91.9375 50.1875Z"
      fill="white"
      fillOpacity="0.1"
    />
    <path
      d="M88.6425 58.1425L97 66.5M91.9375 50.1875C91.9375 56.4007 86.9007 61.4375 80.6875 61.4375C74.4743 61.4375 69.4375 56.4007 69.4375 50.1875C69.4375 43.9743 74.4743 38.9375 80.6875 38.9375C86.9007 38.9375 91.9375 43.9743 91.9375 50.1875Z"
      stroke="#D6E3F0"
      strokeWidth="3"
    />
    <rect x="90.5" y="81" width="105" height="12" rx="2" fill="#D6E3F0" />
    <path
      d="M85.7503 87.0028C85.7503 91.007 82.5042 94.2531 78.5 94.2531C74.4957 94.2531 71.2497 91.007 71.2497 87.0028C71.2497 82.9985 74.4957 79.7525 78.5 79.7525C82.5042 79.7525 85.7503 82.9985 85.7503 87.0028Z"
      fill="#E9EFF5"
    />
    <path
      d="M75 87L77.5 89.5L82.5 84.5M85.7503 87.0028C85.7503 91.007 82.5042 94.2531 78.5 94.2531C74.4957 94.2531 71.2497 91.007 71.2497 87.0028C71.2497 82.9985 74.4957 79.7525 78.5 79.7525C82.5042 79.7525 85.7503 82.9985 85.7503 87.0028Z"
      stroke="#D6E3F0"
      strokeWidth="1.5"
    />
    <rect x="90.5" y="105" width="105" height="12" rx="2" fill="#D6E3F0" />
    <path
      d="M85.7503 111.003C85.7503 115.007 82.5042 118.253 78.5 118.253C74.4957 118.253 71.2497 115.007 71.2497 111.003C71.2497 106.999 74.4957 103.752 78.5 103.752C82.5042 103.752 85.7503 106.999 85.7503 111.003Z"
      fill="#E9EFF5"
    />
    <path
      d="M75 111L77.5 113.5L82.5 108.5M85.7503 111.003C85.7503 115.007 82.5042 118.253 78.5 118.253C74.4957 118.253 71.2497 115.007 71.2497 111.003C71.2497 106.999 74.4957 103.752 78.5 103.752C82.5042 103.752 85.7503 106.999 85.7503 111.003Z"
      stroke="#D6E3F0"
      strokeWidth="1.5"
    />
    <rect x="90.5" y="129" width="105" height="12" rx="2" fill="#D6E3F0" />
    <path
      d="M85.7503 135.003C85.7503 139.007 82.5042 142.253 78.5 142.253C74.4957 142.253 71.2497 139.007 71.2497 135.003C71.2497 130.999 74.4957 127.752 78.5 127.752C82.5042 127.752 85.7503 130.999 85.7503 135.003Z"
      fill="#E9EFF5"
    />
    <path
      d="M75 135L77.5 137.5L82.5 132.5M85.7503 135.003C85.7503 139.007 82.5042 142.253 78.5 142.253C74.4957 142.253 71.2497 139.007 71.2497 135.003C71.2497 130.999 74.4957 127.752 78.5 127.752C82.5042 127.752 85.7503 130.999 85.7503 135.003Z"
      stroke="#D6E3F0"
      strokeWidth="1.5"
    />
    <rect x="90.5" y="153" width="105" height="12" rx="2" fill="#D6E3F0" />
    <path
      d="M85.7503 159.003C85.7503 163.007 82.5042 166.253 78.5 166.253C74.4957 166.253 71.2497 163.007 71.2497 159.003C71.2497 154.999 74.4957 151.752 78.5 151.752C82.5042 151.752 85.7503 154.999 85.7503 159.003Z"
      fill="#E9EFF5"
    />
    <path
      d="M75 159L77.5 161.5L82.5 156.5M85.7503 159.003C85.7503 163.007 82.5042 166.253 78.5 166.253C74.4957 166.253 71.2497 163.007 71.2497 159.003C71.2497 154.999 74.4957 151.752 78.5 151.752C82.5042 151.752 85.7503 154.999 85.7503 159.003Z"
      stroke="#D6E3F0"
      strokeWidth="1.5"
    />
    <g filter="url(#filter2_d)">
      <path
        d="M237.595 32.0108C237.595 47.5272 225.016 60.1058 209.5 60.1058C193.984 60.1058 181.405 47.5272 181.405 32.0108C181.405 16.4944 193.984 3.91583 209.5 3.91583C225.016 3.91583 237.595 16.4944 237.595 32.0108Z"
        fill="#CDDFFA"
      />
      <path
        d="M209.5 47.5V28.125M209.5 22.3125V16.5M237.595 32.0108C237.595 47.5272 225.016 60.1058 209.5 60.1058C193.984 60.1058 181.405 47.5272 181.405 32.0108C181.405 16.4944 193.984 3.91583 209.5 3.91583C225.016 3.91583 237.595 16.4944 237.595 32.0108Z"
        stroke="#3574D4"
        strokeWidth="3"
      />
    </g>
    <circle cx="133.5" cy="101" r="40" fill="white" fillOpacity="0.4" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M133.595 65.6006C113.993 65.6006 98.1008 81.4975 98.1008 101.109C98.1008 120.72 113.993 136.617 133.595 136.617C153.197 136.617 169.089 120.72 169.089 101.109C169.089 81.4975 153.197 65.6006 133.595 65.6006ZM94.1008 101.109C94.1008 79.2898 111.782 61.6006 133.595 61.6006C155.408 61.6006 173.089 79.2898 173.089 101.109C173.089 122.928 155.408 140.617 133.595 140.617C111.782 140.617 94.1008 122.928 94.1008 101.109ZM132.294 87.3876C133.398 87.3876 134.294 88.283 134.294 89.3876V105.286L147.166 111.002C148.175 111.451 148.63 112.633 148.182 113.642C147.734 114.652 146.552 115.106 145.542 114.658L131.482 108.414C130.76 108.093 130.294 107.377 130.294 106.586V89.3876C130.294 88.283 131.189 87.3876 132.294 87.3876Z"
      fill="#92B0CE"
    />
    <defs>
      <filter
        id="filter0_d"
        x="0.5"
        y="102"
        width="112"
        height="73"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0666667 0 0 0 0 0.168627 0 0 0 0 0.266667 0 0 0 0.18 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d"
        x="52.5"
        y="19"
        width="162"
        height="168"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0666667 0 0 0 0 0.168627 0 0 0 0 0.266667 0 0 0 0.18 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d"
        x="174.5"
        y="-1"
        width="70"
        height="70"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0666667 0 0 0 0 0.168627 0 0 0 0 0.266667 0 0 0 0.18 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default OnfidoCheckError;
